import { type Scope, createContextScope } from '@radix-ui/react-context'
import { TagIcon } from './components/tag-icon'
import { TagLabel } from './components/tag-label'
import { TagRootVariants } from './tag.styles'
import type { TagContext, TagProps, TagScopedProps } from './tag.types'

export const DISPLAY_NAME = 'Tag'

type TagRootProps = TagProps

const TagRoot = (props: TagRootProps) => {
  const { children, variants, __scopeTag } =
    props as TagScopedProps<TagRootProps>

  return (
    <TagProvider variants={variants} scope={__scopeTag}>
      <div data-testid="tag-root" className={TagRootVariants({ variants })}>
        {children}
      </div>
    </TagProvider>
  )
}

const [createTagContext] = createContextScope(DISPLAY_NAME)

export const [TagProvider, useTagContext]: readonly [
  ProviderType<TagContext>,
  (consumerName: string, scope: Scope) => TagContext,
] = createTagContext<TagContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const Tag = {
  Root: TagRoot,
  Label: TagLabel,
  Icon: TagIcon,
}
